export const DEBOUNCE_COMMON_TIMEOUT_IN_MS = 200
export const DEBOUNCE_SEARCH_TIMEOUT_IN_MS = 1000
